import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { isEmpty } from 'lodash';
import { Destroyer } from 'src/app/core/abstract/destroyer';
import { ServerNumberFilterValue } from 'src/app/core/models/filters.models';

@Component({
  selector: 'craft-filter-number',
  templateUrl: './craft-filter-number.component.html',
  styleUrls: ['./craft-filter-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CraftFilterNumberComponent extends Destroyer implements OnChanges {
  @Input() public buttonText: string;
  @Input() public selectedValue: ServerNumberFilterValue;

  @Output() public apply = new EventEmitter<ServerNumberFilterValue | undefined>();
  @Output() public remove = new EventEmitter<void>();

  constructor() {
    super();
  }

  @HostBinding('class.active')
  public get isAnySelect() {
    return !isEmpty(this.selectedValue);
  }

  public get buttonExtendedText(): string {
    const val = this.selectedValue;
    const min = typeof val?.min === 'number' ? `Min ${val.min}` : '';
    const max = typeof val?.max === 'number' ? `Max ${val.max}` : '';
    const noVal = val?.noValue ? 'no value' : '';
    const extraText = min && max ? `${val!.min}—${val!.max}` : min || max || noVal;
    return extraText ? `${this.buttonText}: ${extraText}` : this.buttonText;
  }

  public get isBetweenChecked() {
    if (!this.selectedValue) return false;
    return typeof this.selectedValue.max === 'number' || typeof this.selectedValue.min === 'number';
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.selectedValue && !changes.selectedValue.currentValue) {
      this.selectedValue = {};
    }
  }

  public setNumberValue(key: 'min' | 'max', value: number | null) {
    this.selectedValue[key] = value ?? void 0;
  }

  public setNoValue(change: MatCheckboxChange) {
    this.selectedValue.noValue = change.checked;
  }

  public resetNumbers(change: MatCheckboxChange) {
    if (!change.checked) {
      this.selectedValue.min = void 0;
      this.selectedValue.max = void 0;
    }
  }

  public removeFilter(e: MouseEvent) {
    e.stopPropagation();
    this.remove.emit();
  }

  public clearSelected(e?: MouseEvent) {
    this.selectedValue = {};
    this.applyFilters(e);
  }

  public applyFilters(e?: MouseEvent) {
    e?.stopPropagation();
    this.apply.next(this.selectedValue);
  }
}
